export default __webpack_public_path__ + "static/station-location-d-ab8c86e3a6fbe7c62c7f01faf370059a.jpg";